import { render, staticRenderFns } from "./MasterdataNavigation.vue?vue&type=template&id=081e8f9c"
import script from "./MasterdataNavigation.vue?vue&type=script&lang=js"
export * from "./MasterdataNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports